export enum AppMode {
    JobVacancy = 'JobVacancy',
    Candidate = 'Candidate',
    Both = 'Both'
}
